import { createEntityAdapter } from "@reduxjs/toolkit";

import { createReduxStore } from "./redux_store";

const adapter = createEntityAdapter({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

const OrgStore = createReduxStore({ name: "org", adapter });

export { OrgStore };
